import { render, staticRenderFns } from "./FaceSelector.vue?vue&type=template&id=b6d4ccf2&scoped=true&"
import script from "./FaceSelector.vue?vue&type=script&lang=js&"
export * from "./FaceSelector.vue?vue&type=script&lang=js&"
import style0 from "./FaceSelector.vue?vue&type=style&index=0&id=b6d4ccf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d4ccf2",
  null
  
)

export default component.exports